export const DELETE_ENGAGEMENT = 'DELETE_ENGAGEMENT';
export const HIDE_EMAIL_TRACKING = 'HIDE_EMAIL_TRACKING';